import React from 'react';
import { Lock } from 'lucide-react';
import { getLocationDisplayName } from '../utils/locationDisplay';

interface InactiveLocationBannerProps {
  locationName: string;
  className?: string;
}

const InactiveLocationBanner: React.FC<InactiveLocationBannerProps> = ({ locationName, className = '' }) => (
  <div
    className={`mb-4 flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700 flex-shrink-0 ${className}`}
  >
    <Lock className="w-4 h-4 flex-shrink-0" />
    <span>
      <strong>{getLocationDisplayName({ name: locationName, isActive: false })}</strong> is read-only. You can
      view existing data but cannot create, update, or delete records for this location.
    </span>
  </div>
);

export default InactiveLocationBanner;
